// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","container":"_3w4DdxFNtNo7laM_cBNLsk _15-uIrn7gODHiOpUuDWjwC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-group/ProductGroup.css
// module id = 1068
// module chunks = 1